import Slider from "./slider";
export default Slider;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/react-slick/es/index.js
// module id = 3786
// module chunks = 0